export type AnnexType = "normative" | "informative";
export type PiiRole = "controller" | "processor" | "both";
export type SectionType = "main_body" | "annex";

export interface AnnexProfile {
  annexId: string;
  annexType: AnnexType;
  clausePattern: RegExp;
  roleFilter?: "controller" | "processor";
  label: string;
}

export interface StandardProfile {
  standardCode: string;
  displayName: string;
  hasRoleSelection: boolean;
  annexes: AnnexProfile[];
}

export const STANDARD_PROFILES: StandardProfile[] = [
  {
    standardCode: "ISO_27001",
    displayName: "ISO/IEC 27001:2022",
    hasRoleSelection: false,
    annexes: [
      {
        annexId: "A",
        annexType: "normative",
        clausePattern: /^A\.\d/,
        label: "Annex A — Information Security Controls",
      },
    ],
  },
  {
    standardCode: "ISO_27701",
    displayName: "ISO/IEC 27701:2019",
    hasRoleSelection: true,
    annexes: [
      {
        annexId: "A",
        annexType: "normative",
        clausePattern: /^A\.\d/,
        roleFilter: "controller",
        label: "Annex A — PII Controller Controls",
      },
      {
        annexId: "B",
        annexType: "normative",
        clausePattern: /^B\.\d/,
        roleFilter: "processor",
        label: "Annex B — PII Processor Controls",
      },
      {
        annexId: "C",
        annexType: "informative",
        clausePattern: /^C\.\d/,
        label: "Annex C — Mapping to ISO/IEC 29100",
      },
      {
        annexId: "D",
        annexType: "informative",
        clausePattern: /^D\.\d/,
        label: "Annex D — Mapping to GDPR",
      },
      {
        annexId: "E",
        annexType: "informative",
        clausePattern: /^E\.\d/,
        label: "Annex E — Mapping to ISO/IEC 27018 and ISO/IEC 29151",
      },
      {
        annexId: "F",
        annexType: "informative",
        clausePattern: /^F\.\d/,
        label:
          "Annex F — How to Apply ISO/IEC 27701 to ISO/IEC 27001 and ISO/IEC 27002",
      },
    ],
  },
  {
    standardCode: "ISO_42001",
    displayName: "ISO/IEC 42001:2023",
    hasRoleSelection: false,
    annexes: [
      {
        annexId: "A",
        annexType: "normative",
        clausePattern: /^A\.\d/,
        label: "Annex A — AI Management System Controls",
      },
      {
        annexId: "B",
        annexType: "informative",
        clausePattern: /^B\.\d/,
        label: "Annex B — Implementation Guidance",
      },
      {
        annexId: "C",
        annexType: "informative",
        clausePattern: /^C\.\d/,
        label: "Annex C — Potential AI-Related Objectives and Risk Sources",
      },
      {
        annexId: "D",
        annexType: "informative",
        clausePattern: /^D\.\d/,
        label: "Annex D — Use of the AI Management System Across Domains",
      },
    ],
  },
];

export function findProfileByCode(code: string): StandardProfile | undefined {
  const normalized = code.toUpperCase().replace(/[\s\-/:]+/g, "_");
  return STANDARD_PROFILES.find((p) => {
    const coreNumber = p.standardCode.replace(/^[A-Z]+_/, "");
    return normalized.includes(coreNumber);
  });
}
